import React from 'react';

import { createRoot } from 'react-dom/client';

import { AppProviders } from '@compositeComponents/app-providers/Providers/AppProviders';
import { initializeReactGa, initializeTagManager, registerServiceWorker } from '@setup/config';
import { initMixpanel } from '@setup/config/mixpanel';

import App from './App';

const initializeProductionConfig = () => {
  if (process.env.REACT_APP_ENV === 'production') {
    initMixpanel();
    initializeTagManager();

    initializeReactGa();
  }
};

const renderApp = () => {
  const root = createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <AppProviders>
      <App />
    </AppProviders>,
  );
};

const initializeApp = () => {
  registerServiceWorker();
  initializeProductionConfig();
  renderApp();
};

initializeApp();
